import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import styles from './OrderTransaction.module.css'
import {
  IconButton
} from 'components/Order/OrderForms/OrderForm/OrderPointsForm/OrderPointsGroupForm/OrderPointForm/IconButton'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import {
  ContainerColumn
} from 'components/Order/OrderForms/OrderForm/OrderPointsForm/OrderPointsGroupForm/OrderPointForm/ContainerColumn'
import { PriceForm } from 'components/Order/OrderForms/OrderForm/PriceForm'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { CreateContractorDialog } from 'components/Contractors'
import ContractorRole from 'constants/ContractorRole'
import { useFormikContext } from 'formik'
import { ORDER_TRANSACTION_PAYMENT_DATE_WRITE, useAuth } from 'context/auth'
import { LinearLoader } from 'components/Shared/LinearLoader'
import { FieldComponent } from 'components/Shared/FieldComponent'
import InputAdornment from '@material-ui/core/InputAdornment'
import { ContractorSelectField } from '../../../../../../Carrier/CarrierSelectField'
import { TransactionType } from "./TransactionType";

export function OrderTransactionForm ({
  number,
  name,
  transactionType,
  onRemoveClick,
  onContractorCreated,
  transactionServiceTypes,
  disabled
}) {
  const [createdContractorWithName, setCreatedContractorWithName] = useState()
  const { setFieldValue } = useFormikContext()
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  function contractorCreated (contractor) {
    if (contractor) {
      onContractorCreated(contractor)
      setFieldValue(`${name}.contractorId`, contractor.id)
    }
    setCreatedContractorWithName(null)
  }

  const onContractorChange = (id, value) => {
    if (value) {
      setFieldValue(`${name}.paymentDays`, transactionType === TransactionType.Income
          ? value.incomePaymentDueDays
          : value.costPaymentDueDays)
    }
  }

  return (
    <div className={styles.root}>
      <ContainerColumn>
        <CreateContractorDialog
          requiredRoles={[ContractorRole.CLIENT]}
          open={!!createdContractorWithName}
          newContractorName={createdContractorWithName}
          onClose={contractorCreated}/>
        <div className="d-flex">
          <div className="d-flex">
            <div className={styles.numberBox}>{number}</div>
            <div className={styles.titleBox}>{t('form.order.transaction.orderTransactionType.' + transactionType)}</div>
          </div>
          <div className={styles.line}/>
          <div className={styles.utilityButtonsContainer}>
            {!disabled && <IconButton
              onClick={() => onRemoveClick()}
              icon={<TrashIcon/>}/>
            }
          </div>
        </div>
        <div className={styles.body}>
          <ContractorSelectField
            fieldName={`${name}.contractorId`}
            label={t(`form.order.transaction.${transactionType}.contractor`)}
            onChange={onContractorChange}
            onContractorCreated={onContractorCreated}
            disabled={disabled}
          />
          {transactionServiceTypes ?
            <ControlledSelectField
              options={transactionServiceTypes}
              fieldName={`${name}.serviceTypeId`}
              label={t(`form.order.transaction.${transactionType}.type`)}
              disabled={disabled}
              disableClear
            /> :
            <LinearLoader/>
          }
          <div className={styles.row}>
            <PriceForm name={name} disabled={disabled}/>
            <div className={styles.fieldHorizontalSeparator}/>
            <div className={styles.paymentDaysField}>
              <FieldComponent
              type={'number'}
              label={'form.order.transaction.paymentDays'}
              fieldName={`${name}.paymentDays`}
              endAdornmentRenderer={() =><InputAdornment position="end">{t('form.order.transaction.paymentDaysAdornment')}</InputAdornment>}
              disabled={disabled || !hasAnyPrivileges([ORDER_TRANSACTION_PAYMENT_DATE_WRITE])}
            />
            </div>
          </div>
          <FieldComponent
            fieldName={`${name}.comment`}
            label={'form.order.transaction.comment'}
          />
        </div>
      </ContainerColumn>
    </div>
  )
}
